if (!customElements.get('free-samples')) {
  customElements.define(
    'free-samples',
    class FreeSamples extends HTMLElement {
      constructor() {
        super();
      }

      freeSamplesUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.freeSamplesUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.onCartUpdate();
        });
      }

      disconnectedCallback() {
        if (this.freeSamplesUpdateUnsubscriber) {
          this.freeSamplesUpdateUnsubscriber();
        }
      }

      onCartUpdate() {
        const sections = this.getSectionsToRender().map((section) => section.section);

        fetch(`${routes.cart_url}?sections=${sections}`)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            this.renderContents(parsedState);
          })
          .catch((e) => {
            console.error(e);
          });
      }

      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace && section.section in parsedState) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }
        });
      }

      getSectionsToRender() {
        return [
          {
            id: `FreeSamples-${this.dataset.sectionId}`,
            section: this.dataset.sectionId,
            selector: 'free-samples',
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.js-contents',
          },
        ];
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }
    }
  );
}
